import Flex from "@/components/flex"
import { RESOURCE_META } from "@/constants/resource-const"
import { carbonBundle } from "./carbon-const"

const CarbonCard = ({ item, lang }) => {
  const resource = RESOURCE_META[item.key]

  return (
    <div className="py-5 max-w-56">
      <Flex className="justify-start md:justify-between items-center gap-3 md:gap-0">
        <div
          className={`
            w-11 h-11 shrink-0 rounded-xl
            flex items-center justify-center
            ${resource.colors.iconBg}
          `}
        >
          <img src={resource.imgSrc} alt="" className="w-5 h-5" />
        </div>

        <div
          className={`
            ${lang === "ko" ? "md:w-50" : "md:w-55"}
            text-left md:text-right
          `}
        >
          <p className="font-semibold text-gray-800">
            {carbonBundle.resources[item.key].title[lang]}
          </p>

          <p className="font-bold text-gray-900 gap-2 flex items-end justify-start md:justify-end">
            {item.value?.toLocaleString()} <span className="text-sm text-gray-500">kgCO₂</span>
            <span className={`text-xs ${resource.colors.text}`}>{item.ratio}%</span>
          </p>
        </div>
      </Flex>
    </div>
  )
}

export default CarbonCard
